import React, { Fragment } from "react";
import { Container, Row } from "reactstrap";
import TermsContent from "./TermsConditionsContent";

const TermsConditions = () => {
    return (
        <Fragment>
            <section className="section bg-home-2 align-items-center">
                <Container>
                    <Row className="align-items-center">
                        <TermsContent />
                    </Row>
                </Container>
            </section>
        </Fragment>
    )
}

export default TermsConditions;